(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/hooks/pix-tips.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/hooks/pix-tips.js');
"use strict";

const {
  productIds,
  getSpecificDrawName
} = svs.utils.products;
const {
  helpers: {
    getNumberOfRows
  }
} = svs.components.sport.quickplayModal;

function resolveFlavour(productId) {
  switch (productId) {
    case productIds.CHALLENGE:
      return 'SafeChallenge';
    default:
      return 'Safe1X2';
  }
}

async function queryTipsPixAsync(_ref) {
  let {
    drawNumber,
    systemCost,
    productId,
    rowPrice
  } = _ref;
  const path = "/wager/1/".concat(getSpecificDrawName(productId), "/pix?flavour=").concat(resolveFlavour(productId), "&systemType=MSys&systemNumberMapping=").concat(getNumberOfRows(systemCost, rowPrice), "&drawNumber=").concat(drawNumber);

  const {
    response
  } = await svs.core.jupiter.callAsync({
    method: 'POST',
    path
  });
  if (response.error || !response.pixes && !response.pix) {
    var _response$error;
    throw new Error(((_response$error = response.error) === null || _response$error === void 0 ? void 0 : _response$error.message) || 'Failed to query wager-API');
  }
  return response.pixes || [response.pix];
}

const _convertTipsBoardToWager = board => {
  const newBoard = [];
  board.forEach(_ref2 => {
    let {
      outcomes
    } = _ref2;
    const newOutcomes = [];
    if (outcomes.find(_ref3 => {
      let {
        value
      } = _ref3;
      return value === '1';
    })) {
      newOutcomes.push('1');
    }
    if (outcomes.find(_ref4 => {
      let {
        value
      } = _ref4;
      return value === 'X';
    })) {
      newOutcomes.push('X');
    }
    if (outcomes.find(_ref5 => {
      let {
        value
      } = _ref5;
      return value === '2';
    })) {
      newOutcomes.push('2');
    }
    newBoard.push(newOutcomes.join(''));
  });
  return newBoard;
};

const _convertTipsBoardToSigns = board => {
  const signs = [];
  board.forEach(_ref6 => {
    let {
      outcomes
    } = _ref6;
    const newOutcomes = [];
    newOutcomes.push(Boolean(outcomes.find(_ref7 => {
      let {
        value
      } = _ref7;
      return value === '1';
    })));
    newOutcomes.push(Boolean(outcomes.find(_ref8 => {
      let {
        value
      } = _ref8;
      return value === 'X';
    })));
    newOutcomes.push(Boolean(outcomes.find(_ref9 => {
      let {
        value
      } = _ref9;
      return value === '2';
    })));
    signs.push(newOutcomes);
  });
  return signs;
};

function normaliseTipsPix(_ref10) {
  let {
    data = [],
    productId,
    drawNumber,
    systemCost,
    systemType
  } = _ref10;
  if (!Array.isArray(data) || data.length === 0) {
    throw new Error('Missing "pix.events" in response from wager-API.');
  }
  return {
    productId,
    drawNumber,
    systemCost,
    systemType,
    signsByEventForOutput: {
      game1X2: _convertTipsBoardToSigns(data[0].events)
    },
    wagerBoardData: {
      game1X2: _convertTipsBoardToWager(data[0].events)
    }
  };
}

setGlobal('svs.components.sport.quickplayModal.hooks', {
  queryTipsPixAsync,
  normaliseTipsPix
});

 })(window);